import { useContext } from 'react';

import { Flex } from '@chakra-ui/react';
import OverviewSection from 'Deer/components/Overview/OverviewSection';
import useLocalStorageCards from 'Deer/hooks/useLocalStorageCards';
import { ProfileContext } from 'Deer/pages/Profile/hooks/ProfileContext';
import { setIsCardOpen } from 'Deer/slice/DeerCollapsibleCard.slice';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useMySummaryReviews } from 'screens/home/summary/components/Cards/Reviews/hooks';
import { checkNewStaticDataFeaturesEnabled } from 'utils/helpers/featureFlags';
import { getUniqueCardKey } from 'utils/helpers/getUniqueCardKey';

import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { ReviewsCards } from './ReviewsCards';
import { ReviewsChart } from './ReviewsChart';

export const ReviewsOverview = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const employeeContext = useContext(ProfileContext);

  const currentURL = history.location.pathname;

  // Generate the key using getUniqueCardKey function
  const localStorageKey = getUniqueCardKey({ url: currentURL, cardId: 'myDataReviewsOverview' });

  const isCardOpen = useLocalStorageCards({
    localStorageKey,
    card: 'reviewsOverview',
    section: 'myData',
  });

  // @ts-expect-error API to be integrated? @nimmi to confirm
  const { data: pendingReviews, isLoading: isLoadingReviewSectionsData } = useMySummaryReviews({
    employeeId: employeeContext?.id ? employeeContext.id : null,
    limit: 50,
    offset: 0,
    sectionId: 'PENDING_ON_ME',
    refetchOnWindowFocus: false,
  });

  const dataForCards = pendingReviews?.data?.map(({ employee, review }) => ({
    employee,
    review,
  }));

  const handleChange = (newVal: boolean) => {
    dispatch(
      setIsCardOpen({
        card: 'reviewsOverview',
        section: 'myData',
        isCardOpen: newVal,
        localStorageKey,
      })
    );
    return newVal;
  };

  if (isLoadingReviewSectionsData) {
    return <SkeletonLoader />;
  }

  return (
    <OverviewSection
      open={isCardOpen}
      onOpenChange={handleChange}
      subTitle="Congratulations on your consistent progress towards your goals! However, there hasn't been notable development in certain competencies this past year. Maven suggests exploring ways to demonstrate the 'Collaboration' competency in your upcoming 1:1. Let's unlock your full potential together!"
      subTitleColor="success"
      title="Reviews"
      showCaption={pendingReviews?.data.length > 0 && checkNewStaticDataFeaturesEnabled() && !employeeContext}
    >
      <Flex width="full" minHeight="full" flexDirection={{ base: 'column', md: 'row' }} gap="8px">
        <Flex flex="0.6">
          <ReviewsChart />
        </Flex>

        <Flex flex="0.4">
          <ReviewsCards cards={dataForCards} cardTitle="Pending reviews" />
        </Flex>
      </Flex>
    </OverviewSection>
  );
};
